/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable max-len */
/* eslint-disable no-empty */
/* eslint-disable no-console */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-async-promise-executor */
/* eslint-disable no-await-in-loop */
import requester from '../../utils/requester';
import config from '../../config';
import offlineDB from '../index';


const syncOfflineAnimals = () => new Promise(async (resolve, reject) => {

    // Algorithm of submitting offline animals:
    // check offline files, upload them first => update in animal
    // check new farm, add them first => update in animal
    // send animal to the server => delete animal from offlineDB

    try {
        const userInfo = await requester.authNeed().contentType('application/json').get(config.serverURL + '/user');
        if (userInfo?.data?.results?.id) {
            const userId = userInfo.data.results.id;

            const offlineAnimalsList = await offlineDB.syncAnimals.getAnimalsList();
            if (offlineAnimalsList?.success) {
                if (offlineAnimalsList?.data?.length) {
                    // just selected items related to currect user to sync
                    const filteredListByUserId = offlineAnimalsList.data
                        .filter(item => item?.userId?.toString() === userId.toString());

                    for (const singleAnimal of filteredListByUserId) {

                        const animalSaveObject = {}; // to make an animal object in required format to submit


                        // upload avatar and save returned url
                        const animalAvatarOfflineDBID = (singleAnimal?.image?.offlineDBID) || null;
                        if (animalAvatarOfflineDBID) {
                            try {
                                const avatarOnOfflineDB = await offlineDB
                                    .files.getFile(animalAvatarOfflineDBID);
                                if (avatarOnOfflineDB) {
                                    const blob = avatarOnOfflineDB.file;
                                    const formData = new FormData();
                                    formData.append('fileupload', blob, 'fileupload.jpg');
                                    const uploadResult = await requester
                                        .contentType(false).authNeed()
                                        .post(config.serverURL + '/upload', formData, true);
                                    if (uploadResult?.data?.results?.[0]?.uri) {
                                        const uploadedURL = uploadResult.data.results[0].uri;
                                        animalSaveObject.image = uploadedURL;
                                        try {
                                            offlineDB.files.deleteFile(animalAvatarOfflineDBID);
                                        }
                                        catch { }
                                    }
                                    else {
                                        // failed to upload file
                                        try {
                                            offlineDB.files.deleteFile(animalAvatarOfflineDBID);
                                        }
                                        catch { }
                                    }
                                }
                            }
                            catch { }
                        }


                        // upload attachments and save returned urls array
                        const animalAttachmentsList = singleAnimal?.attachment || null;
                        if (animalAttachmentsList?.length) {
                            const attachmentsList = [];
                            for (const singleAttachment of singleAnimal.attachment) {

                                if (singleAttachment?.offlineDBID) {
                                    try {
                                        const fileOnOfflineDB = await offlineDB
                                            .files.getFile(singleAttachment.offlineDBID);
                                        if (fileOnOfflineDB?.success) {

                                            const file = fileOnOfflineDB.file;
                                            const formData = new FormData();
                                            formData.append('fileupload', file, file.name);
                                            const uploadResult = await requester.contentType(false)
                                                .authNeed().post(config.serverURL + '/upload', formData, true);
                                            if (uploadResult?.data?.results?.[0]?.uri) {
                                                attachmentsList.push(uploadResult.data.results[0].uri);
                                                try {
                                                    offlineDB.files.deleteFile(singleAttachment.offlineDBID);
                                                }
                                                catch { }
                                            }
                                            else {
                                                // failed to upload file
                                                try {
                                                    offlineDB.files.deleteFile(singleAttachment.offlineDBID);
                                                }
                                                catch { }
                                            }
                                        }
                                    }
                                    catch (err) { console.log(err) }
                                }
                            }
                            animalSaveObject.attachment = attachmentsList;
                        }


                        // check if entered farm is new, then create it
                        const animalFarm = singleAnimal?.farm || null;
                        if (animalFarm.isNew) {
                            const newFarm = await requester.contentType('application/json').authNeed().post(config.serverURL + '/farms', { name: animalFarm.value });
                            if (newFarm?.data?.results?.length) {
                                animalSaveObject.farmId = parseInt(newFarm.data.results[0].farmId);
                            }
                            else {
                                // if faild, the most possible reason could be name existence, so add (2) and try again
                                const newFarmNameModified = await requester.contentType('application/json').authNeed().post(config.serverURL + '/farms', { name: animalFarm.value + ' (2)' });
                                if (newFarmNameModified?.data?.results?.length) {
                                    animalSaveObject.farmId = parseInt(newFarmNameModified.data.results[0].farmId);
                                }
                            }
                        }
                        else {
                            animalSaveObject.farmId = parseInt(animalFarm.value);
                        }

                        animalSaveObject.earTagNo = singleAnimal.earTagNo; // required field
                        animalSaveObject.gender = singleAnimal.gender; // required field
                        singleAnimal.name && (animalSaveObject.name = singleAnimal.name);
                        singleAnimal.age && (animalSaveObject.age = singleAnimal.age.toString());
                        singleAnimal.timeOnFarm && (animalSaveObject.timeOnFarm = Number(singleAnimal.timeOnFarm));
                        singleAnimal.dob && (animalSaveObject.dob = singleAnimal.dob);
                        singleAnimal.sire && (animalSaveObject.sire = singleAnimal.sire);
                        singleAnimal.breedId && (animalSaveObject.breedId = singleAnimal.breedId);
                        singleAnimal.deviceMac && (animalSaveObject.deviceMac = singleAnimal.deviceMac.toString());
                        singleAnimal.weight && (animalSaveObject.weight = singleAnimal.weight + ' grams');

                        const newAnimal = await requester.contentType('application/json').authNeed().post(config.serverURL + '/animals', animalSaveObject);

                        if ((newAnimal?.data?.results?.affectedRows === 1)) {
                            // delete animal from offline sync store after submit
                            try {
                                offlineDB.syncAnimals.deleteAnimal(singleAnimal.offlineId);
                            }
                            catch { reject(); }
                        }
                    }
                    resolve(); // resolve after loop
                }
                else { resolve(); } // offline animals list is empty
            }
            else { reject('error - syncOfflineAnimals'); }
        }
        else {
            reject('error - syncOfflineAnimals - user not found');
        }
    }
    catch (error) { console.log(error); reject('error - syncOfflineAnimals - outer'); }
});

export default syncOfflineAnimals;
